import {
  Component,
} from "react";
import {
  ANTRAGSTATUS,
  ANTRAGSTELLERMODUS,
  getModusFromAntrag,
} from "App/constants";
import Confirmation from "CommonComponents/confirmation";
import apifetch from "CommonCore/apifetch";
import store from "CommonState/store";
import {
  Button,
} from "react-bootstrap";
import {
  notifyPopup,
} from "CommonCore/util";

@store("flag_antragstellermodus")
export default class AntragVertragPopup extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    let { flag_antragstellermodus } = this.props;
    const { onCancel, antrag } = this.props;
    const { errorMessage } = this.state;

    if (!flag_antragstellermodus) {
      flag_antragstellermodus = getModusFromAntrag(antrag);
    }

    const modus = ANTRAGSTELLERMODUS[flag_antragstellermodus];

    const erneut = antrag.a_asid == ANTRAGSTATUS.STATUS_VERTRAGSUNTERLAGEN_UNVOLLSTAENDIG;

    return (
      <Confirmation
        header={`${ modus.labelVertrag } als ${ erneut ? " erneut " : "" } eingereicht erklären`}
        action='Vertrag ist vollständig eingereicht'
        actionStyle='primary'
        onCancel={onCancel}
        onConfirm={this.onConfirm}
        errorMessage={errorMessage}
        extraButtons={<>
          <Button variant='primary' onClick={() => {
            this.onConfirmTeilweise();
          }}>
            Vertragsunterlagen {erneut ? " weiterhin" : " bisher"} nur teilweise eingereicht
          </Button>
        </>}
      >
        <span><h4>{modus.labelVertrag} als {erneut ? "erneut" : ""} eingereicht erklären</h4>
          <p>Wenn der {modus.labelVertrag} in unterschriebener Form im Personaldezernat angekommen ist,
            können Sie den zugehörigen Status hier setzen, um die Bearbeitung abschließen zu können.
          </p>
          <p>Bitte geben Sie dabei an, ob die Unterlagen {erneut ? "nun" : "bereits"} vollständig sind.</p>
          <br /></span>

      </Confirmation>
    );
  }

  onConfirm = async() => {
    return await this.onConfirmTeilweise(true);
  };

  onConfirmTeilweise = async vollstaendig => {
    const { a_id } = this.props;
    try {
      await apifetch("/api/shkantrag/massnahmevorgesehen/dienstvertrageinreichen", {
        method: "POST",
        body: { a_id: a_id, vollstaendig: !!vollstaendig },
      });

      notifyPopup("Der Status wurde gesetzt und der Antragsteller per Mail benachrichtigt.");
    } catch(err) {
      this.setState({
        errorMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
    this.props.onClose();
  };
}
